class BlogPostsHoverList extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.mainViews = [...this.querySelectorAll('[data-main-view]')];
        this.listItems = [...this.querySelectorAll('[data-list-item]')];
        this.initialized = false;

        this.init();
    }

    init() {
        // 设置第一个项目为活动状态
        if (this.mainViews.length > 0 && this.listItems.length > 0) {
            this.setActiveMainView(this.mainViews[0]);
            this.setActiveListItem(this.listItems[0]);
        }

        // 为列表项添加鼠标悬停事件
        this.listItems.forEach(item => {
            item.addEventListener('mouseenter', this.onListItemHover.bind(this));
            item.addEventListener('click', this.onListItemClick.bind(this));
        });

        // 移除加载状态
        this.classList.remove('loading');
        this.initialized = true;
    }
    
    onListItemHover(e) {
        // 仅在桌面设备上启用悬停效果
        if (window.innerWidth >= 768) {
            const item = e.currentTarget;
            const articleId = item.dataset.articleId;

            if (!articleId) return;

            const mainArticleView = this.mainViews.find(view => view.dataset.articleId === articleId);

            if (mainArticleView) {
                this.setActiveListItem(item);
                this.setActiveMainView(mainArticleView);
            }
        }
    }

    onListItemClick(e) {
        // 在所有设备上使用点击来展开/折叠内容
        const item = e.currentTarget;
        const articleId = item.dataset.articleId;

        if (!articleId) return;

        const mainArticleView = this.mainViews.find(view => view.dataset.articleId === articleId);

        if (mainArticleView) {
            // 如果当前项已经是活动状态，则切换内容的显示/隐藏
            if (item.classList.contains('is-active')) {
                // 在桌面设备上，点击已激活的项目时切换其展开状态
                item.classList.toggle('content-expanded');
            } else {
                // 移除所有项的内容展开状态和活动状态
                this.listItems.forEach(listItem => {
                    listItem.classList.remove('content-expanded', 'is-active');
                });
                
                // 设置当前项为活动状态并展开内容
                item.classList.add('content-expanded', 'is-active');
                this.setActiveMainView(mainArticleView);
                
                // 在移动设备上滚动到视图
                if (window.innerWidth < 768) {
                    this.scrollToView(mainArticleView);
                }
            }
        }
    }

    setActiveListItem(activeItem) {
        this.listItems.forEach(item => {
            item.classList.remove('is-active');
        });
        activeItem.classList.add('is-active');
    }

    setActiveMainView(activeView) {
        this.mainViews.forEach(view => {
            view.classList.remove('is-active');
        });
        activeView.classList.add('is-active');
    }

    scrollToView(activeView) {
        if (window.innerWidth < 768) {
            const topSpace = activeView.getBoundingClientRect().top;
            const headerHeight = document.querySelector('sticky-header') ? document.querySelector('sticky-header').clientHeight : 0;
            window.scrollBy({
                top: topSpace - 15 - headerHeight,
                behavior: 'smooth'
            });
        }
    }
}

window.addEventListener('load', () => {
    customElements.define('blog-posts-hover-list', BlogPostsHoverList);
});